/** 内测用户协议与隐私说明（简版，内测占位） */

export const USER_AGREEMENT_TITLE = '内测用户协议';

export const USER_AGREEMENT_SECTIONS = [
  {
    title: '服务性质',
    body: 'AIVideoClip 当前处于内测阶段，功能可能变更或中断。内测期间服务完全免费，不构成任何付费承诺。',
  },
  {
    title: '数据与存储',
    body: '上传的原片与切片默认保留 24 小时，到期自动清理。请及时下载所需文件，平台不对过期数据负责。',
  },
  {
    title: '账号与配额',
    body: '每位用户按当前档位享有上传大小、视频时长与切片次数限制。测试期免费档临时为单文件 1.5GB、时长 60 分钟；正式收费上线后免费档将恢复为 1GB / 45 分钟（日/月次数不变）。滥用、刷量或攻击行为可能导致账号禁用。',
  },
  {
    title: '内容与合规',
    body: '您应确保上传内容合法，不侵犯他人权益。平台有权删除违规内容并配合监管要求。',
  },
];

export const PRIVACY_NOTICE_TITLE = '隐私说明';

export const PRIVACY_NOTICE_SECTIONS = [
  {
    title: '收集的信息',
    body: '内测阶段主要收集邮箱、密码哈希、用量统计与操作日志，用于账号识别、配额控制与故障排查。',
  },
  {
    title: '视频文件',
    body: '视频仅用于切片处理与临时存储，不会在未经您同意的情况下公开展示或用于模型训练（内测阶段）。',
  },
  {
    title: '收费预告',
    body: '正式收费前将提前公告（计划不少于 30 天）。内测用户档位标签可能调整；测试期临时放宽的免费额度（1.5GB / 60 分钟）将在正式收费上线后恢复为 1GB / 45 分钟。',
  },
];
